import { Component, OnInit } from "@angular/core";
import { EngagementService } from "../../services/engagement.service";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { ScenarioResult } from "../../models/scenarioResult.model";
import { Sharedservice } from "./../../shared-components/shared.service";
import { ScenarioExecutionService } from "../../services/scenarioexecution.service";
import { MessageService, ConfirmationService } from "primeng/api";
import {
  severitymessage,
  LanguageConstants,
  FunctionalityNames,
} from "../../shared-components/constant";
import { UserService } from "../../services/user.service";
import { UserModel } from "../../models/user.model";
import { UserInputsService } from "src/app/services/user-inputs.service";
import { PeriodService } from "src/app/services/period.service";
import { InfraService } from "src/app/services/infra.service";
import { PeriodPreferenceModel } from "src/app/models/period-preference.model";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { AuditingService } from "../../services/auditing.service";

enum AssessmentStatus {
  AllSuccess = 1,
  AllFailure = 2,
  Partial = 3,
}

enum AccountCalendar {
  P12 = 1,
  P13 = 2,
  P445 = 3,
  P454 = 4,
  P544 = 5,
}

@Component({
  selector: "app-scenarioresult",
  templateUrl: "./scenarioresult.component.html",
  styleUrls: ["./scenarioresult.component.css"],
})
export class ScenarioresultComponent implements OnInit {
  langCode: string;
  currLangTranslation: any;
  nextStep: any;
  previousStep: any;

  constructor(
    private infraService: InfraService,
    private engagementService: EngagementService,
    private route: ActivatedRoute,
    private router: Router,
    public sharedService: Sharedservice,
    private scenarioExecutionService: ScenarioExecutionService,
    private userInputsService: UserInputsService,
    private messageService: MessageService,
    private userService: UserService,
    private confirmationService: ConfirmationService,
    private periodService: PeriodService,
    private translateService: TranslateService,
    private auditingService: AuditingService
  ) {
    this.infraService.infraDetails$.subscribe((data) => {
      this.regionId = data.InfraId;
    });

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInUserId = userData.Id;
      }
    });
  }
  showMainContent: Boolean = true;
  value = 0;
  AssessmentProgress = 0;
  scenarioResults: ScenarioResult[];
  filteredResults: ScenarioResult[];
  processedResults: { FiscalYear: string; ProcessedMonths: number }[];
  statuses: any[] = [];
  cols: any[];
  processedResultsCols: any[];
  engagementId = +this.route.snapshot.paramMap.get("id");

  isHidden = true;
  isCancelButtonDisabled = true;
  loadspinner = false;
  show = false;
  private loggedInUserId: number;
  totalTabsCount = 0;
  timeOutHandler: NodeJS.Timer;
  isTimeIntervalInProgress = false;
  isFreshRequest = true;
  isComponentLinkAcive = false;
  isNextButtonDisable = true;
  scenarioWarningKey = "Warning";
  scenarioConfirmPopup = false;
  showWarningPopup = false;
  displayEmailNotification = false;
  displayP445EmailNotification = false;
  isProcessAssessmentButtonHidden = true;

  displayWarningMessage = false;
  displayWarningMessageCancelClicked = true;

  mappingStructureList: any[];
  showMappingStructureIssue = false;
  private regionId: number;

  confirmdisplay = false;
  accountCalendarId: number;
  isEndDateMismatch: boolean = false;
  endDatePreference = "0";

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation =
      this.translateService.translations[this.langCode];
    this.nextStep = this.currLangTranslation.actionButtons.nextStep;
    this.previousStep = this.currLangTranslation.actionButtons.previousStep;

    this.translateService.onLangChange.subscribe(
      (langEvent: LangChangeEvent) => {
        this.currLangTranslation = langEvent.translations;
        this.previousStep = this.currLangTranslation.actionButtons.previousStep;
        this.nextStep = this.currLangTranslation.actionButtons.nextStep;
      }
    );

    this.sharedService.setactiveindex(3);
    this.cols = [
      { field: "sourceFileId", header: "SourceFileId", visible: false },
      {
        field: "fileName",
        header: "step4.fileName",
        visible: true,
        title: "List of uploaded source files",
      },
      { field: "tabId", header: "step4.tabId", visible: false },
      {
        field: "tabName",
        header: "step4.tabName",
        visible: true,
        title: "List of Tabs in each File",
      },
      {
        field: "status",
        header: "step4.dataProcessed",
        visible: true,
        title: "Flat file can be creatable for the file/tab",
      },
      {
        field: "error",
        header: "step4.errorDetails",
        visible: true,
        title: "Error if any",
      },
    ];

    this.processedResultsCols = [
      {
        field: "FiscalYear",
        header: "step4.fiscalYear",
        visible: true,
        title: "Fiscal year",
      },
      {
        field: "ProcessedMonths",
        header: "step4.processedMonths",
        visible: true,
        title: "No of month processed",
      },
    ];

    this.statuses = [
      { label: "Yes", value: "Yes", title: "File is processed" },
      { label: "No", value: "No", title: "File not processed" },
    ];

    this.engagementService
      .getEngagement(this.engagementId)
      .subscribe((data) => {
        this.accountCalendarId = data.AccCalendarId;
      });
    this.displayEmailNotification = false;
    this.displayP445EmailNotification = false;
    this.isFreshRequest = true;
    this.getScenarioResults();
  }

  public showCancelButton(obj: any) {
    obj.isCancelButtonDisabled = false;
  }
  public cancelClicked() {
    this.scenarioExecutionService
      .requestAssessmentCancellation(this.engagementId)
      .subscribe(
        (resp) => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.success,
            summary: this.currLangTranslation.severitymessage.notification,
            detail:
              this.currLangTranslation.severitymessage
                .AssessmentCancelRequested,
            sticky: true,
            closable: true,
          });
        },
        (err) => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
        }
      );
  }

  private displayEmailNotificationMessage(obj: any) {
    if (
      obj.accountCalendarId === AccountCalendar.P445 ||
      obj.accountCalendarId === AccountCalendar.P454 ||
      obj.accountCalendarId === AccountCalendar.P544
    ) {
      obj.displayP445EmailNotification = true;
    } else {
      obj.displayEmailNotification = true;
    }
  }

  public getScenarioResults() {
    this.loadspinner = true;
    this.engagementService
      .getDataForScenarioAssesment(this.engagementId)
      .subscribe(
        (data: ScenarioResult[]) => {
          this.totalTabsCount = data.length;
          this.scenarioResults = data;
          this.scenarioResults.map((resp) => {
            switch (resp.assessmentStatus) {
              case 1:
                resp.statusIcon = "fa fa-check-circle customicon";
                break;
              case 2:
                resp.statusIcon = "fa fa-exclamation-triangle customiconyello";
                break;
              case 0:
                resp.statusIcon = "fa fa-times-circle customiconred";
                break;
            }
          });
          const newTabs = this.scenarioResults.filter(
            (x) =>
              x.isError === false &&
              (x.assessmentStatus == null || x.assessmentStatus === 0)
          );
          const processedTabs = this.scenarioResults.filter(
            (x) => x.isProcessed === true
          );

          //TODO - Revert for Bug 4660829
          // const isQueued = this.scenarioResults.filter(
          //   (x) => x.isQueued === true
          // );

          this.isNextButtonDisable = false;
          // If all tabs are processed..
          if (this.scenarioResults.length === processedTabs.length) {
            this.getProcessedTabSummary(AssessmentStatus.AllSuccess);
            this.loadspinner = false;
            this.isHidden = false;
            return;
          }
          // No new tabs are available
          if (newTabs.length === 0) {
            const erroredTabs = this.scenarioResults.filter(
              (x) => x.isError === true
            );
            // All tabs are failed
            if (
              erroredTabs.length === this.scenarioResults.length &&
              erroredTabs.length > 0
            ) {
              this.isNextButtonDisable = true;
              this.getProcessedTabSummary(AssessmentStatus.AllFailure);
            } else {
              this.getProcessedTabSummary(AssessmentStatus.Partial);
            }
            this.isProcessAssessmentButtonHidden = false;
            this.loadspinner = false;
            this.isHidden = false;
            return;
          }

          const assessmentEamilNotification = this.scenarioResults.filter(
            (x) => x.isAssessmentEmailRequired === true
          );
          if (assessmentEamilNotification.length > 0) {
            this.getProcessedTabSummaryWithCallback(
              this.displayEmailNotificationMessage
            );
            return;
          }
          if (!environment.isWebJobEnabled) {
            this.executeScenario(this.filteredResults);
          } else {
            if (newTabs.length > 0) {
              //TODO - Revert for Bug 4660829
              // && !(isQueued.length > 0)
              this.addMessageToQueue();
            } else {
              this.messageService.add({
                key: this.currLangTranslation.severitymessage.key,
                severity: severitymessage.error,
                summary: this.currLangTranslation.severitymessage.notification,
                detail:
                  this.currLangTranslation.step4.dataProcessingInProgressText1,
                sticky: true,
                closable: true,
              });
              this.loadspinner = false;
            }
          }
        },
        (error) => {
          this.messageService.add({
            key: this.currLangTranslation.severitymessage.key,
            severity: severitymessage.error,
            summary: this.currLangTranslation.severitymessage.notification,
            detail: this.currLangTranslation.severitymessage.somethingwrong,
            sticky: true,
            closable: true,
          });
          this.loadspinner = false;
        }
      );
  }

  public processAssessment() {
    this.loadspinner = true;
    this.addMessageToQueue();
  }

  private addMessageToQueue() {
    this.scenarioExecutionService
      .addMessageIntoAzureQueue(
        this.engagementId,
        this.loggedInUserId,
        this.regionId
      )
      .subscribe(
        (resp) => {
          this.checkSourceFilesTabsProcessed();
        },
        (err) => {
          this.loadspinner = false;
          this.confirmationService.confirm({
            message: this.currLangTranslation.step4.confirm,
            header: this.currLangTranslation.step4.errorScenarioExecution,
            acceptLabel: this.currLangTranslation.actionButtons.yes,
            rejectLabel: this.currLangTranslation.actionButtons.no,
            accept: () => {
              this.showWarningPopup = false;
              this.getScenarioResults();
            },
            reject: () => {
              this.scenarioResults.map((sr) => {
                if (!sr.isProcessed) {
                  sr.error =
                    this.currLangTranslation.step4.errorScenarioExecution;
                }
              });
            },
          });
        }
      );
  }

  private executeScenario(filteredResult: ScenarioResult[]) {
    const isSuccessFlag = false;
    if (this.filteredResults.length > 0) {
      this.scenarioExecutionService
        .executeScenario(this.filteredResults, this.engagementId)
        .subscribe(
          (resp) => {
            this.loadspinner = false;
            this.isHidden = false;
          },
          (err) => {}
        );
    } else {
      this.loadspinner = false;
      this.isHidden = false;
    }
  }

  private checkMappingStructure(assessmentStatus: number) {
    this.scenarioExecutionService
      .checkMappingStructure(this.engagementId)
      .subscribe(
        (res: any[]) => {
          this.showMappingStructureIssue = false;
          if (res.length > 0) {
            this.mappingStructureList = res;
            this.showMappingStructureIssue = true;
            this.isNextButtonDisable = true;
          }
          if (assessmentStatus === AssessmentStatus.Partial) {
            this.DisplayWarningPopup();
          }
          this.loadspinner = false;
        },
        (err) => {
          this.loadspinner = false;
          this.isNextButtonDisable = true;
        }
      );
  }

  private checkSourceFilesTabsProcessed() {
    this.scenarioExecutionService
      .checkSourceFilesTabsProcessed(this.engagementId)
      .subscribe(
        (resp: any[]) => {
          if (resp.length > 0) {
            if (resp[0].CancellationStatus === 2) {
              this.deleteProcessingData();
            }
            const assessmentEamilNotification = resp.filter(
              (x) => x.isAssessmentEmailRequired === true
            );
            if (assessmentEamilNotification.length > 0) {
              assessmentEamilNotification.map((sr) => {
                const row = this.scenarioResults.find((r) => r.tabId == sr.id);
                row.error = sr.error;
              });
              this.getProcessedTabSummaryWithCallback(
                this.displayEmailNotificationMessage
              );
              clearInterval(this.timeOutHandler);
              this.isTimeIntervalInProgress = false;
              this.isNextButtonDisable = true;
              this.isFreshRequest = false;
              this.isHidden = false;
              this.loadspinner = false;
              return;
            }

            if (this.AssessmentProgress < resp[0].assessmentProgress) {
              this.AssessmentProgress = resp[0].assessmentProgress;
              if (resp[0].assessmentProgress * 10 > 100) {
                this.value = 100;
              } else {
                this.value = resp[0].assessmentProgress * 10;
              }
            }

            const errorRows = resp.filter((x) => x.assessmentStatus === 0);
            const processedRows = resp.filter(
              (x) => x.assessmentStatus != null
            );
            this.isNextButtonDisable = errorRows.length === resp.length;
            this.scenarioResults.map((sr) => {
              const row = resp.find((r) => r.id == sr.tabId);
              switch (row.assessmentStatus) {
                case 1:
                  sr.statusIcon = "fa fa-check-circle customicon";
                  sr.error = "";
                  break;
                case 2:
                  sr.statusIcon = "fa fa-exclamation-triangle customiconyello";
                  sr.error = row.error;
                  break;
                case 0:
                  sr.statusIcon = "fa fa-times-circle customiconred";
                  sr.error = row.error;
                  break;
                case null:
                  sr.statusIcon = "";
                  sr.error = row.error;
                  break;
              }
            });

            if (resp.length === processedRows.length) {
              const erroredRows = resp.filter(function (x) {
                return x.assessmentStatus === 0;
              });
              if (erroredRows.length > 0 && erroredRows.length <= resp.length) {
                this.isProcessAssessmentButtonHidden = false;
                erroredRows.length === resp.length
                  ? this.getProcessedTabSummary(AssessmentStatus.AllFailure)
                  : this.getProcessedTabSummary(AssessmentStatus.Partial);
              } else {
                this.isProcessAssessmentButtonHidden = true;
                this.getProcessedTabSummary(AssessmentStatus.AllSuccess);
              }
              clearInterval(this.timeOutHandler);
              this.isTimeIntervalInProgress = false;
              this.isFreshRequest = false;
              this.isHidden = false;
              this.loadspinner = false;
            } else {
              if (!this.isTimeIntervalInProgress) {
                this.timeOutHandler = setInterval(() => {
                  this.isTimeIntervalInProgress = true;
                  this.isFreshRequest = false;
                  this.loadspinner = true;
                  this.checkSourceFilesTabsProcessed();
                }, environment.webjobTimer);
              }
            }
          }
        },
        (err) => {}
      );
  }

  closeEventworkallocation($event) {
    this.confirmdisplay = $event;
  }

  previousButton() {
    this.confirmdisplay = false;
    this.sharedService.setactiveindex(2);
    this.router.navigate(["/engagement/", this.engagementId, "inputcapture"]);
  }

  nextClicked() {
    this.showMainContent = false;
    if (this.isEndDateMismatch) {
      this.updateEndDates();
    }
    if (!this.isNextButtonDisable) {
      this.UpdateMapping1();
    }
    this.messageService.clear();
  }

  getProcessedTabSummary(assessmentStatus: number) {
    this.loadspinner = true;
    this.engagementService.getProcessedTabSummary(this.engagementId).subscribe(
      (data: { FiscalYear: string; ProcessedMonths: number }[]) => {
        this.processedResults = data;
        this.checkMappingStructure(assessmentStatus);
        if (AssessmentStatus.AllFailure != assessmentStatus) {
          this.periodService
            .IsEndDateMismatchExist(this.engagementId)
            .subscribe((periodResp) => {
              if (periodResp) {
                this.isEndDateMismatch = true;
              }
            });
        }
      },
      (error) => {
        this.loadspinner = false;
      }
    );
  }

  onPropertyChange(val) {}

  getProcessedTabSummaryWithCallback(callBack) {
    this.engagementService.getProcessedTabSummary(this.engagementId).subscribe(
      (data: { FiscalYear: string; ProcessedMonths: number }[]) => {
        this.processedResults = data;
        this.loadspinner = false;
        callBack(this);
      },
      (error) => {
        this.loadspinner = false;
        this.showWarningPopup ? this.DisplayWarningPopup() : "";
      }
    );
  }

  UpdateMapping1() {
    if (!this.isNextButtonDisable) {
      this.loadspinner = true;
      this.router.navigate([
        "/engagement/",
        this.engagementId,
        "mappingselection",
      ]);
    }
  }

  DisplayWarningPopup() {
    this.displayWarningMessage = true;
  }

  confirmPopupAccept() {
    this.scenarioConfirmPopup = false;
    if (!this.isEndDateMismatch) {
      this.UpdateMapping1();
    }
  }

  confirmPopupReject() {
    this.scenarioConfirmPopup = false;
    this.router.navigate(["/engagement/", this.engagementId, "inputcapture"]);
  }

  deleteProcessingData() {
    this.userInputsService.deleteProcessingData(this.engagementId).subscribe(
      (response: any) => {
        this.sharedService.setactiveindex(2);
        this.router.navigate([
          "/engagement/",
          this.engagementId,
          "inputcapture",
        ]);
      },
      (error) => {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }

  public CloseInfoPopup() {
    this.displayEmailNotification = false;
    this.displayP445EmailNotification = false;
  }

  public accept() {
    this.displayWarningMessageCancelClicked = false;
    this.displayWarningMessage = false;
    this.router.navigate([
      "/engagement/",
      this.engagementId,
      "uploaddownloadflatfile",
      { src: "assessment" },
    ]);
  }

  public reject() {
    this.displayWarningMessageCancelClicked = true;
    this.displayWarningMessage = false;
    this.showWarningPopup = false;
    this.scenarioConfirmPopup = true;
  }

  public clickProcessAssessment() {
    this.displayWarningMessageCancelClicked = false;
    this.displayWarningMessage = false;
    this.processAssessment();
  }

  public cancel(clickVal) {
    if (this.displayWarningMessageCancelClicked === true) {
      this.reject();
    }
    this.displayWarningMessageCancelClicked = true;
  }

  updateEndDates() {
    const periodPreferenceModel = new PeriodPreferenceModel();
    periodPreferenceModel.EngagementId = this.engagementId;
    periodPreferenceModel.PeriodPreference = this.endDatePreference === "1";
    periodPreferenceModel.QueueIdentifier = 17; // Queueid for CapIQFromFlatfile from assessment

    if (periodPreferenceModel.PeriodPreference)
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.EndDateBasedOnSourceFile
        )
        .subscribe();
    else
      this.auditingService
        .addAudit(
          this.engagementId,
          FunctionalityNames.EndDateBasedOnProjectInput
        )
        .subscribe();

    this.periodService.UpdatePeriodPreference(periodPreferenceModel).subscribe(
      () => {
        this.isEndDateMismatch = false;
        this.UpdateMapping1();
      },
      (err) => {
        this.loadspinner = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key,
          severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification,
          detail: this.currLangTranslation.severitymessage.somethingwrong,
          sticky: true,
          closable: true,
        });
      }
    );
  }
}
